import axios from "axios";
import { BASE_URL } from "./api";

export async function getPeople(token, queryParams) {
  return axios({
    method: "get",
    url: `${BASE_URL}/people${queryParams}`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function updatePerson(token, personId, data) {
  return axios({
    method: "patch",
    url: `${BASE_URL}/people/${personId}/`,
    headers: {
      Authorization: `Token ${token}`,
    },
    data: data
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    });
}

export async function createPerson(token, data) {
  return axios({
    method: "post",
    url: `${BASE_URL}/people/`,
    headers: {
      Authorization: `Token ${token}`,
    },
    data: data
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    });
}

export async function adminCreateUserFromPerson(token, data, personId) {
  return axios({
    method: "post",
    url: `${BASE_URL}/people/${personId}/create_user/`,
    headers: {
      Authorization: `Token ${token}`,
    },
    data: data
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    });
}